import { useEffect, useRef } from 'react';
import * as echarts from 'echarts';

/**
 * Thin React wrapper over Apache ECharts (no echarts-for-react dep).
 * Inits once, re-applies `option` on change, and resizes with the
 * container via a ResizeObserver. Disposes on unmount.
 */
export function EChart({ option, height = 260, className }: { option: echarts.EChartsOption; height?: number; className?: string }) {
  const ref = useRef<HTMLDivElement | null>(null);
  const chart = useRef<echarts.ECharts | null>(null);

  useEffect(() => {
    if (!ref.current) return;
    chart.current = echarts.init(ref.current);
    const ro = new ResizeObserver(() => chart.current?.resize());
    ro.observe(ref.current);
    return () => { ro.disconnect(); chart.current?.dispose(); chart.current = null; };
  }, []);

  useEffect(() => {
    chart.current?.setOption(option, true);
  }, [option]);

  return <div ref={ref} style={{ height }} className={className} />;
}
